/**
 * aggiunge un contenuto al menu corrente
 */
function addContentToMenu(id, type, contentIdentifier, title, contentType, contentTypeId, isNew) {

    if(id == "" && type == "link") {
        id = Date.now();
    }

    if(type == "content" || type == "link") {

        var now = Date.now();

        if(type == "content") {
            now = id;
        }

        var newElement = '<li id="menu-item-id-'+now+'" data-id="menu-item-id-'+id+'" class="list-group-item" data-type="'+type+'" data-content-id="'+contentIdentifier+'" data-content-type-id="'+contentTypeId+'">' +
            '<a href="javascript:removeContentFromMenu(\'menu-item-id-'+id+'\', \''+type+'\', \'menu-item-id-'+now+'\');" class="btn btn-danger btn-flat btn-xs pull-right">' +
            '<em class="fa fa-times-circle"></em>' +
            '</a>';

        newElement += '<div class="form-group">' +
            '<label>Titolo</label>' +
            '<input name="menu-item-name" type="text" value="'+title+'" class="form-control">' +
            '<input type="checkbox" name="menu-item-new" '+(isNew ? 'checked' : '')+'> Novità' +
            '</div>';

        if(type == "content") {

            newElement +=
            '<input name="menu-item-content" type="hidden" value="'+contentIdentifier+'" class="form-control">'+ contentType+': '+title;
            $(".data-content-id-"+contentIdentifier).removeClass("btn-primary");
            $(".data-content-id-"+contentIdentifier).attr("disabled","disabled");

        }
        if(type == "link") {
            newElement +=
            '<label>Url</label>' +
            '<input name="menu-item-link" type="text" value="'+contentIdentifier+'" class="form-control">';

            $("#new-link-url,#new-link-title").val("");
        }

        newElement += '</li>';

        $("ul#menu-items-sortable-list").append(newElement);

        serializeMenuItems();
    }
}

function removeContentFromMenu(id, type, elementId) {

    if(type == "content" || type == "link") {

        if(type == "content") {

            id = id.replace("menu-item-id-", "");

            $(".data-content-id-"+id).addClass("btn-primary");
            $(".data-content-id-"+id).attr("disabled", false);
        }
        $("#"+elementId).remove();

        serializeMenuItems();
    }
}

/**
 * generazione array menu per salvataggio
 * @type {Array}
 */
var menuItemsOrder = new Array();

/**
 * sortable menu
 */
var menuItemsList = $("ul#menu-items-sortable-list").sortable({
    delay: 250,
    onDrop: function ($item, container, _super) {
        serializeMenuItems();

        _super($item, container);
    }
});

/**
 * serializza e aggiorna la lista dei menuItems
 */
function serializeMenuItems() {

    var data = menuItemsList.sortable("serialize").get();
    var order = new Array();

    for(var i = 0; i < data[0].length; i++) {
        var link = "";
        var contentIdentifier = data[0][i].contentId;
        if(data[0][i].type == "link") {
            link = $("#"+data[0][i].id).find("input[name='menu-item-link']").val();
            contentIdentifier = link;
        } else {
            link = data[0][i].contentId;
        }
        var title = $("#"+data[0][i].id).find("input[name='menu-item-name']").val();
        var isNew = $("#"+data[0][i].id).find("input[name='menu-item-new']").is(':checked') ? 1 : 0;

        order.push(new Array(
            data[0][i].type,
            data[0][i].contentTypeId,
            title,
            link,
            isNew
        ));
    }
    menuItemsOrder = JSON.stringify(order);
    $("#new-positions").val(menuItemsOrder.toString());

    console.log(menuItemsOrder);
}

/**
 * aggiorna la lista dei menuItems quando viene cambiato un titolo o un link
 */
$(document).on("change paste keyup", 'input[name="menu-item-name"], input[name="menu-item-link"], input[name="menu-item-new"]', function () {
    serializeMenuItems();
});